export default __webpack_public_path__ + "static/media/about_office1.e3cda75a.jpeg";